import { httpClient, httpClient2 } from '@/api';

// 查询批次图片
export const _getMarkList = ({ canteenId, apiKey, dateRange }) => {
  return httpClient
    .post(
      `data_mark/list`,
      {
        canteen_id: canteenId,
        collect_time_range: dateRange
      },
      {
        headers: {
          'api-key': apiKey
        }
      }
    )
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(res.data.error_msg));
      }
    });
};
// 查询batch
export const _getBatchList = ({
  machine_id,
  canteen_id,
  apiKey,
  collect_time_range
}) => {
  return httpClient
    .post(
      `data_mark_batch/list`,
      {
        machine_id,
        canteen_id,
        collect_time_range
      },
      {
        headers: {
          'api-key': apiKey
        }
      }
    )
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(res.data.error_msg));
      }
    });
};
// 查询批次图片
export const _getBatchImageList = ({ apiKey, canteen_id, batch }) => {
  return httpClient
    .post(
      `data_mark/list/by_batch`,
      {
        canteen_id,
        batch
      },
      {
        headers: {
          'api-key': apiKey
        }
      }
    )
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _markBatchImages = ({
  apiKey,
  canteen_id,
  label_info_list,
  batch
}) => {
  console.log(label_info_list);
  return httpClient
    .post(
      `data_mark/mark/by_batch`,
      {
        batch,
        canteen_id,
        label_info_list
      },
      {
        headers: {
          'api-key': apiKey
        }
      }
    )
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.erro_msg}`));
      }
    });
};
export const _changeBatchState = ({
  system_id = 1,
  batch_tag,
  batch_state,
  batch_comment = '',
  apiKey
}) => {
  return httpClient2
    .post(
      `/batch/postBatchState`,
      { system_id, batch_tag, batch_state, batch_comment },
      {
        headers: {
          'api-key': apiKey
        }
      }
    )
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
export const _batchChange = batch => {
  return httpClient
    .post(`data/batch/change`, { batch })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    })
    .catch(e => {
      return Promise.reject(e);
    });
};
export const _regionImgByUuid = img_uuid => {
  return httpClient
    .post(`region_img/get_by_img_uuid`, { img_uuid })
    .then(res => {
      if (res.data.state_code === 0) {
        return Promise.resolve(res.data.data);
      } else {
        return Promise.reject(new Error(`${res.data.error_msg}`));
      }
    });
};
